import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Stack } from "@origin-digital/ods-core";
import {
  navigation,
  type INavigationData,
} from "@origin-digital/reporting-client";
import { Head } from "../../components/Head/Head";
import { PrerenderReadyMarker } from "../../components/PrerenderReadyMarker";
import { IMetadata } from "../../interface/metadata";

interface IPageTemplateProps {
  "data-id"?: string;
  metadata?: IMetadata;
  children: React.ReactNode;
  /** Whether this page's async content has finished loading - see PrerenderReadyMarker. */
  isReady?: boolean;
}

export const PageTemplate = ({
  "data-id": dataId,
  metadata,
  children,
  isReady = true,
}: IPageTemplateProps) => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    const normalizedPath = pathname.replace(/\/$/, "");
    const isSearchRoute = normalizedPath.endsWith("/search");
    const searchTerm = isSearchRoute
      ? new URLSearchParams(search).get("term") || undefined
      : undefined;

    const navigationData: INavigationData & { searchTerm?: string } = {
      currentUri: window.location.host + window.location.pathname,
      friendlyUri: pathname
        .replace(/\/$/, "")
        .replace(/^\//, "")
        .replace(/\//g, ":"),
      searchTerm,
    };

    navigation("screen", navigationData);
  }, [pathname, search]);

  return (
    <Stack data-id={dataId} space="none">
      <Head metadata={metadata} />
      <div />
      {children}
      <div />
      <PrerenderReadyMarker isReady={isReady} />
    </Stack>
  );
};
